import { createSlice } from '@reduxjs/toolkit';

// Define the initial state
const initialState = {
  patientsList: {
    searchQuery: ''
  }
};

// Create the slice
const patientManagementSlice = createSlice({
  name: 'patientManagementSlice',
  initialState,
  reducers: {
    setPatientsSearchQuery(state, action) {
      state.patientsList.searchQuery = action.payload;
    }
  }
});

export default patientManagementSlice.reducer;

export const { setPatientsSearchQuery } = patientManagementSlice.actions;
